import { SvgIconType } from './svg.interface';

const PdfIcon: SvgIconType = ({
  width = 10,
  height = 12,
  className = '',
  color = '#8792A2'
}) => (
  <svg
    width={width}
    height={height}
    className={className}
    viewBox="0 0 10 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M5.75 3.1875V0H1.0625C0.750778 0 0.5 0.250778 0.5 0.5625V11.4375C0.5 11.7492 0.750778 12 1.0625 12H8.93749C9.24922 12 9.49999 11.7492 9.49999 11.4375V3.75H6.3125C6.00312 3.75 5.75 3.49688 5.75 3.1875ZM7.35616 7.39406L7.62123 7.65914C7.76772 7.80562 7.76772 8.04305 7.62123 8.18953L6.92045 8.89031L7.62499 9.59484C7.77147 9.74133 7.77147 9.97875 7.62499 10.1252L7.35991 10.3903C7.21343 10.5368 6.976 10.5368 6.82952 10.3903L6.12499 9.68555L5.42046 10.3901C5.27398 10.5366 5.03655 10.5366 4.89007 10.3901L4.62499 10.125C4.47851 9.97851 4.47851 9.7411 4.62499 9.59461L5.32952 8.89008L3.93921 7.5H3.49999V8.625C3.49999 8.83219 3.33218 9 3.125 9H2.75C2.54281 9 2.375 8.83219 2.375 8.625V4.875C2.375 4.66781 2.54281 4.5 2.75 4.5H4.625C5.45351 4.5 6.125 5.17148 6.125 6C6.125 6.56766 5.80578 7.05586 5.34077 7.31063L6.125 8.09485L6.82578 7.39406C6.97226 7.24758 7.20969 7.24758 7.35617 7.39406H7.35616ZM4.625 6.375H3.5V5.625H4.625C4.83172 5.625 5 5.79328 5 6C5 6.20671 4.83172 6.37499 4.625 6.37499V6.375ZM9.5 2.85703V3H6.5V0H6.64296C6.79296 0 6.93593 0.0585964 7.0414 0.164063L9.33593 2.46094C9.4414 2.56641 9.49999 2.70938 9.49999 2.85704L9.5 2.85703Z"
      fill={color}
    />
  </svg>
);

export default PdfIcon;
